import { Box } from '../primitives/Box.js';
import { cx } from '../primitives/cx.js';

export type ProgressBarProps = {
  /** 0–1. Clamped, so callers can pass raw ratios without guarding. */
  value: number;
  tone?: 'accent' | 'gold' | 'flame';
  size?: 'sm' | 'md';
  label: string;
  className?: string;
};

const fillClass = {
  accent: 'bg-accent',
  gold: 'bg-gold',
  flame: 'bg-flame',
} as const;

export function ProgressBar({
  value,
  tone = 'accent',
  size = 'md',
  label,
  className,
}: ProgressBarProps) {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100);

  return (
    <Box
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      className={cx(
        'w-full overflow-hidden rounded-full bg-sunken',
        size === 'sm' ? 'h-1.5' : 'h-2.5',
        className,
      )}
    >
      <Box
        className={cx(
          'h-full rounded-full transition-[width]',
          'duration-[var(--aj-duration-slow)] ease-standard motion-reduce:transition-none',
          fillClass[tone],
        )}
        style={{ width: `${pct}%` }}
      />
    </Box>
  );
}
